import { cls } from "@wss/cls";
import React, { useState, useEffect } from "react";
import useCountdown from "~/common/useCountdown";

interface HeroCountdownProps {
  customCountdownText?: string;
  eventStartDate: string;
  eventEndDate: string;
  textColor: string;
}

const HeroCountdown = ({
  customCountdownText,
  eventEndDate,
  textColor,
}: HeroCountdownProps) => {
  const [isDealExpired, setIsDealExpired] = useState<boolean>();
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [isCountingDown, setIsCountingDown] = useState<boolean>();

  const { countdownDisplay, countdownComplete } = useCountdown({
    endDate: new Date(eventEndDate),
  });

  useEffect(() => {
    setIsLoading(false);
  }, []);

  useEffect(() => {
    if (countdownComplete) {
      setIsDealExpired(true);
    }
  }, [countdownComplete]);

  const countdownMessage = () => {
    if (isLoading || (countdownDisplay === "00:00:00" && !isCountingDown)) {
      return "Loading countdown...";
    }

    if (!isCountingDown) {
      setIsCountingDown(true);
    }

    return `${customCountdownText} ${countdownDisplay}`;
  };

  return (
    <div style={{ maxWidth: "1600px", zIndex: 2 }}>
      <div
        className="rounded-t flex items-center justify-center"
        data-testid="hero-countdown"
      >
        {!!customCountdownText && !!eventEndDate && !isDealExpired && (
          <p
            className={`${cls(
              "font-bold",
              "text-xl",
              "leading-none",
              "mb-0",
              countdownMessage() === "Deals Expired"
                ? "text-center"
                : "text-left",
              "text-white",
            )} min-w-[190px]`}
            style={{ color: textColor }}
          >
            {countdownMessage()}
          </p>
        )}
      </div>
    </div>
  );
};

export default HeroCountdown;
